export const firebaseConfig = {
  apiKey: process.env.REACT_APP_NOT_FIREBASE_KEY,
  authDomain: "cv-website-275a8.firebaseapp.com",
  projectId: "cv-website-275a8",
  storageBucket: "cv-website-275a8.appspot.com",
  messagingSenderId: "84867772368",
  appId: "1:84867772368:web:46a1d576a298d544b0d3d5",
  measurementId: "G-XS0HHVZC69"
};
